// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tOZ0","name":"styles_name__1ZQCg","phone":"styles_phone__a_YNu"};